import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.vtovsuperfresh.com/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

// Request interceptor — attach trigram auth headers
api.interceptors.request.use(
  (config) => {
    const role     = localStorage.getItem('erp_role');
    const username = localStorage.getItem('erp_username');
    if (role && username) {
      config.headers['x-role']     = role;
      config.headers['x-username'] = username;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — handle 401 (session expired / unauthorized)
// IMPORTANT: Do NOT redirect when the failing URL is the login endpoint itself.
// If we redirect on a login 401, the error toast never shows — it looks like
// a silent failure on mobile. Only redirect if the user had an established session.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const isLoginRequest = error.config?.url?.includes('/auth/login');
    const isAuthMeRequest = error.config?.url?.includes('/auth/me');

    if (error.response?.status === 401 && !isLoginRequest && !isAuthMeRequest) {
      // Session expired mid-session — clear and redirect
      localStorage.removeItem('erp_role');
      localStorage.removeItem('erp_username');
      localStorage.removeItem('erp_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
